import * as React from 'react'
export const Pw = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333" width="1em" height="1em" {...props}>
    <path fill="#338AF3" d="M0 85.331h512v341.337H0z" />
    <circle cx={218.902} cy={255.994} r={74.207} fill="#FFDA44" />
  </svg>
)
